// extracted by mini-css-extract-plugin
module.exports = {"videoRow":"VideoList_videoRow__25A6r","videoItem":"VideoList_videoItem__3qa5B","customHeader":"VideoList_customHeader__2CVLj","selectedVideos":"VideoList_selectedVideos__2BDSQ"};